import {
  LabelInfo,
  LabelKeys,
  LabelTypesOptions,
} from "@app/types/samples.types";
import { SR_ISOTOPES } from "../../SR/utils/constants";

/* "efficiency_sr_89-id",
"efficiency_sr_90-id",
"efficiency_y_90-id", */

export const labelString: Record<LabelKeys, LabelInfo> = {
  efficiency: {
    label: "Eficiencia",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 1,
    id: "efficiency-id",
  },
  cpm_fondo_beta: {
    label: "cpm fondo beta",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 1,
    id: "cpm_fondo_beta-id",
  },
  efficiency_sr_89: {
    label: "Eficiencia Sr-89",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 1,
    id: "efficiency_sr_89-id",
  },
  efficiency_sr_90: {
    label: "Eficiencia Sr-90",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 1,
    id: "efficiency_sr_90-id",
  },
  efficiency_y_90: {
    label: "Eficiencia Y-90",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 1,
    id: "efficiency_y_90-id",
  },
  cte_desintegration: {
    label: "Cte. Desintegración (min-1)",
    decimals: 5,
    type: LabelTypesOptions.CIENTIFICO,
    order: 2,
    id: "cte_desintegration-id",
  },
  cpm_fondo: {
    label: "cpm fondo",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 2,
    id: "cpm_fondo-id",
  },
  counting_time: {
    label: "Tiempo total contaje fondos (min)",
    decimals: 0,
    type: LabelTypesOptions.NUMERICO,
    order: 2,
    id: "counting_time-id",
  },
  spill_over: {
    label: "Spill-over",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 17,
    id: "spill_over-id",
  },
  time_increase: {
    label: "Incremento del tiempo (min)",
    decimals: 0,
    type: LabelTypesOptions.NUMERICO,
    order: 6,
    id: "time_increase-id",
  },
  inc_squared_spill_over: {
    label: "Incertidumbre al cuadrado del Spill-over. U2 ",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 18,
    id: "inc_squared_spill_over-id",
  },
  error_cpm_contaje_1: {
    label: "2 cpm 1er contaje",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 5,
    id: "error_cpm_contaje_1-id",
  },
  error_cpm_contaje_2: {
    label: "2 cpm 2º contaje",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 6,
    id: "error_cpm_contaje_2-id",
  },
  primary_pattern_activity: {
    label: "Actividad del patrón primario: A0(Bq/mg)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 4,
    id: "primary_pattern_activity-id",
  },
  primary_pattern_uncertainty: {
    label: "Inc. del patrón primario (Bq/mg): uA0 (k=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 5,
    id: "primary_pattern_uncertainty-id",
  },
  primary_pattern_mass_mpp: {
    label: "Masa del patrón primario: mpp (mg)",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 6,
    id: "primary_pattern_mass_mpp-id",
  },
  primary_pattern_mass_uncertainty: {
    label: "Inc. de la masa del patrón primario (mg): umpp (k=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 7,
    id: "primary_pattern_mass_uncertainty-id",
  },
  secondary_pattern_mass: {
    label: "Masa del patrón secundario: mps (mg)",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 8,
    id: "secondary_pattern_mass-id",
  },
  secondary_pattern_mass_uncertainty: {
    label: "Inc. de la masa del patrón secundario (mg): umps (k=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 9,
    id: "secondary_pattern_mass_uncertainty-id",
  },
  inc_of_calibration_source_volume_at_0: {
    label:
      "Incertidumbre del volumen de la fuente de calibración a espesor cero uVfc (ml) (K=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 9,
    id: "inc_of_calibration_source_volume_at_0-id",
  },

  calibration_source_cpm: {
    label: "cpm de la fuente de calibración a espesor cero: cpmfc e=0",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 12,
    id: "calibration_source_cpm-id",
  },
  squared_counting_uncertainty_of_calibration_source_at_0: {
    label:
      "Incertidumbre de recuento al cuadrado de la fuente de calibración a espesor cero: u2cpmfc e=0 (K=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 11,
    id: "squared_counting_uncertainty_of_calibration_source_at_0-id",
  },
  secondary_pattern_activity_of_the_fc_with_the_greatest_amount_AT: {
    label:
      "Actividad patrón secundario de la fuente de calibración a espesor cero: dpmfc e=0",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 12,
    id: "secondary_pattern_activity_of_the_fc_with_the_greatest_amount_AT-id",
  },
  mass_with_greatest_amount_of_scintillator: {
    label: "Masa de la f.c. con mayor cantidad de centelleador. mfc (mg)",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 10,
    id: "mass_with_greatest_amount_of_scintillator-id",
  },
  mass_with_greatest_amount_of_scintillator_AT: {
    label:
      "Volumen de la fuente de calibración a espesor cero. Vfc (ml)mfc extintor=0 (mg)",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 10,
    id: "mass_with_greatest_amount_of_scintillator-id",
  },
  inc_mass_with_greatest_amount_of_scintillator: {
    label:
      "Inc. de la masa de la f.c. con mayor cantidad de centelleador. u(mfc cent=máx) (mg) (k=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 11,
    id: "inc_mass_with_greatest_amount_of_scintillator-id",
  },
  cpm_of_the_fc_with_largest_amount_of_scintillator: {
    label: "cpm de la f.c. con mayor cantidad de centelleador: cpmfc cente=máx",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 12,
    id: "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  },
  inc_count_squared_fc_with_greater_amount_of_scintillator: {
    label:
      "Inc. de recuento al cuadrado de la f.c. con mayor cantidad de centelleador: u2(cpmfc cent=máx) (k=1).",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 13,
    id: "inc_count_squared_fc_with_greater_amount_of_scintillator-id",
  },
  dpm_fc_k40_with_less_kci: {
    label:
      "dpm de K-40 en la fuente de calibración con menor cantidad de KCI: dpm fc k40 KCI=min",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 29,
    id: "dpm_fc_k40_with_less_kci-id",
  },
  secondary_pattern_activity_of_the_fc_with_the_greatest_amount: {
    label:
      "Actividad patrón secundario de la f.c. con mayor cantidad de centelleo a fecha contaje (dpm fc cent=máx).",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 14,
    id: "secondary_pattern_activity_of_the_fc_with_the_greatest_amount-id",
  },
  inc_squared_of_the_activity_of_the_secondary_standard: {
    label:
      "Inc. al cuadrado de la actividad del patrón secundario a espesor cero: u2(dpmfc cent=máx) (k=1).",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 15,
    id: "inc_squared_of_the_activity_of_the_secondary_standard-id",
  },

  inc_squared_dpm_fc_k40_with_less_kci: {
    label:
      "Incertidumbre al cuadrado dpm de K-40 en la fuente de calibración con menor cantidad de KCI: U2 dpm fc k40 KCI=min (k=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 30,
    id: "inc_squared_dpm_fc_k40_with_less_kci-id",
  },
  k40_relative_uncertainty: {
    label:
      "Incertidumbre relativa al cuadrado del factor de auto absorción en la calibración del k-40: U2rel Fa k40 (K=1)",
    decimals: 4,
    type: LabelTypesOptions.CIENTIFICO,
    order: 31,
    id: "k40_relative_uncertainty-id",
  },
  relative_uncertainty: {
    label:
      "Inc. relativa al cuadrado del factor de auto absorción: u2rel Fa (k=1)",
    decimals: 4,
    type: LabelTypesOptions.CIENTIFICO,
    order: 16,
    id: "relative_uncertainty-id",
  },
  uncertainty_squared_relative_inverse_sample_efficiency: {
    label:
      "Incertidumbre al cuadrado de la eficiencia del k-40 en la muestra: U2Ef k40 (K=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 32,
    id: "uncertainty_squared_relative_inverse_sample_efficiency-id",
  },
  inverse_squared_uncertainty: {
    label:
      "Inc. al cuadrado de la inversa de la eficiencia de la muestra: u2W (k=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 17,
    id: "inverse_squared_uncertainty-id",
  },
  inc_rel_squared_sample_vial_quantity: {
    label: "Incertidumbre al cuadrado de la medida de AA: U2mk (mg/l) (k=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 33,
    id: "inc_rel_squared_sample_vial_quantity-id",
  },
  count_uncertainty_squared: {
    label: "Inc. al cuadrado de recuento: u2(cpmm-cpm0) (k=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 18,
    id: "count_uncertainty_squared-id",
  },
  sample_quantity_uncertainty_squared: {
    label: "Inc. al cuadrado de la cantidad de muestra: u2 Cant. muestra (k=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 19,
    id: "sample_quantity_uncertainty_squared-id",
  },
  decay_factor_uncertainty_squared: {
    label:
      "Inc. al cuadrado del factor de decaimiento de la muestra. u2(elDt) (k=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 20,
    id: "decay_factor_uncertainty_squared-id",
  },
  critical_limit: {
    label: "Límite crítico",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICOCONCERO,
    order: 21,
    id: "critical_limit-id",
  },
  tertiary_patron_mass: {
    label: "Masa del patrón terciario: mpt (mg) ",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 9,
    id: "tertiary_patron_mass-id",
  },
  inc_mass_uncertainty_tertiary_pattern: {
    label: "Incertidumbre de la masa del patrón terciario (mg): umpt(k=1) ",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 9,
    id: "inc_mass_uncertainty_tertiary_pattern-id",
  },
  tsie_sqp_patron_without_agent_extintor: {
    label:
      "Masa de fuente de calibración sin agente extintor. mfc extintor=0 (mg) ",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 10,
    id: "tsie_sqp_patron_without_agent_extintor-id",
  },
  inc_tsie_sqp_patron_without_agent_extintor: {
    label:
      "Incertidumbre de la masa de fuente de calibración sin agente extintor. u(mfc extintor=0) (mg) (K=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 12,
    id: "inc_tsie_sqp_patron_without_agent_extintor-id",
  },
  inc_count_squared_fc_without_agent_extintor: {
    label:
      "Incertidumbre de recuento al cuadrado de la fuente de calibración sin agente extintor: u2(cpmfc extintor=0) (K=1)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 13,
    id: "inc_count_squared_fc_without_agent_extintor-id",
  },
  activity_source_calibration_without_agent_extintor: {
    label:
      "Actividad fuente de calibración sin agente extintor (dpm fc extintor=0)",
    decimals: 3,
    type: LabelTypesOptions.NUMERICO,
    order: 14,
    id: "activity_source_calibration_without_agent_extintor-id",
  },

  calibration_source_count_rate_uncertainty_squared: {
    label:
      "Tasa de recuento del k-40 por unidad de volumen o de masa: r k40 (cpm/m3 o kg)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 34,
    id: "calibration_source_count_rate_uncertainty_squared-id",
  },

  inc_squared_activity_source_calibration_without_agent_extintor: {
    label:
      "Incertidumbre al cuadrado de actividad f.c. sin agente extintor: u2(dpmfc extintor=0) (K=1)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 15,
    id: "inc_squared_activity_source_calibration_without_agent_extintor-id",
  },
  br_critical_limit: {
    label: "Límite Critico BR (Aβr*)",
    decimals: 3,
    type: LabelTypesOptions.CIENTIFICO,
    order: 36,
    id: "br_critical_limit-id",
  },

  fanding: {
    label: "Fanding",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 29,
    id: "fanding-id",
  },
  fondo_usv: {
    label: "Fondo USV",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 30,
    id: "fondo_usv-id",
  },
  dosis_transito_usv_dia: {
    label: "Dosis tránsito USV día",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 31,
    id: "dosis_transito_usv_dia-id",
  },
  error_dosis_transito_usv_dia: {
    label: "Error dosis tránsito USV día",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 32,
    id: "error_dosis_transito_usv_dia-id",
  },
  cpm_of_the_fc_with_largest_amount_of_scintillator_AT: {
    label: "cpm de la fuente de calibración a espesor cero: U2cpmfc e=0 (K=1)",
    decimals: 2,
    type: LabelTypesOptions.NUMERICO,
    order: 12,
    id: "cpm_of_the_fc_with_largest_amount_of_scintillator_AT-id",
  },
  sr89_cdes: {
    label: SR_ISOTOPES.SR89.label,
    decimals: 5,
    type: LabelTypesOptions.CIENTIFICO,
    order: 6,
    id: `${SR_ISOTOPES.SR89.key}-id`,
  },
  sr90_cdes: {
    label: SR_ISOTOPES.SR90.label,
    decimals: 5,
    type: LabelTypesOptions.CIENTIFICO,
    order: 7,
    id: `${SR_ISOTOPES.SR90.key}-id`,
  },
  y90_cdes: {
    label: SR_ISOTOPES.Y90.label,
    decimals: 5,
    type: LabelTypesOptions.CIENTIFICO,
    order: 8,
    id: `${SR_ISOTOPES.Y90.key}-id`,
  },
  inc_rel_squared_performance: {
    label: "Rendimiento (%)",
    decimals: 5,
    type: LabelTypesOptions.CIENTIFICO,
    order: 2,
    id: "inc_rel_squared_performance-id",
  },
};

export const idsCurries = [
  "efficiency-id",
  "cte_desintegration-id",
  "time_increase-id",
];

export const idsFe55Ni63 = [
  "efficiency-id",
  "cte_desintegration-id",
  "time_increase-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "tertiary_patron_mass-id",
  "inc_mass_uncertainty_tertiary_pattern-id",
  "inc_tsie_sqp_patron_without_agent_extintor-id",
  "mass_with_greatest_amount_of_scintillator-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  "inc_count_squared_fc_without_agent_extintor-id",
  "activity_source_calibration_without_agent_extintor-id",
  "inc_squared_activity_source_calibration_without_agent_extintor-id",
  "relative_uncertainty-id",
  "uncertainty_squared_relative_inverse_sample_efficiency-id",
  "count_uncertainty_squared-id",
  "inc_rel_squared_sample_vial_quantity-id",
  "inc_rel_squared_performance-id",
  "decay_factor_uncertainty_squared-id",
  "critical_limit-id",
];

export const idsDefault = [
  "efficiency-id",
  "cte_desintegration-id",
  "time_increase-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "relative_uncertainty-id",
  "inverse_squared_uncertainty-id",
  "count_uncertainty_squared-id",
  "sample_quantity_uncertainty_squared-id",
  "decay_factor_uncertainty_squared-id",
  "critical_limit-id",
  "inc_mass_with_greatest_amount_of_scintillator-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  "inc_count_squared_fc_with_greater_amount_of_scintillator-id",
  "secondary_pattern_activity_of_the_fc_with_the_greatest_amount-id",
  "inc_squared_of_the_activity_of_the_secondary_standard-id",
  "mass_with_greatest_amount_of_scintillator-id",
];

export const idsAT = [
  "efficiency-id",
  "cpm_fondo-id",
  "counting_time-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "mass_with_greatest_amount_of_scintillator_AT-id",
  "inc_mass_with_greatest_amount_of_scintillator-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator_AT-id",
  "squared_counting_uncertainty_of_calibration_source_at_0-id",
  "secondary_pattern_activity_of_the_fc_with_the_greatest_amount_AT-id",
  "inc_squared_of_the_activity_of_the_secondary_standard-id",
  "relative_uncertainty-id",
  "inverse_squared_uncertainty-id",
  "count_uncertainty_squared-id",
  "sample_quantity_uncertainty_squared-id",
  "critical_limit-id",
];

export const idsIodo: string[] = [
  "efficiency-id",
  "cte_desintegration-id",
  "time_increase-id",
  "cpm_fondo-id",
  "counting_time-id",
];

export const idsSR: string[] = [
  "efficiency_sr_89-id",
  "efficiency_sr_90-id",
  "efficiency_y_90-id",
  "cpm_fondo-id",
  "counting_time-id",
  "error_cpm_contaje_1-id",
  "error_cpm_contaje_2-id",
  "sr89_cdes-id",
  "sr90_cdes-id",
  "y90_cdes-id",
];

export const idsDP: string[] = [
  "fanding-id",
  "fondo_usv-id",
  "dosis_transito_usv_dia-id",
  "error_dosis_transito_usv_dia-id",
];

export const idsBTBR: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "inc_of_calibration_source_volume_at_0-id",
  "squared_counting_uncertainty_of_calibration_source_at_0-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  "inc_count_squared_fc_without_agent_extintor-id",
  "secondary_pattern_activity_of_the_fc_with_the_greatest_amount-id",
  "inc_squared_of_the_activity_of_the_secondary_standard-id",
  "relative_uncertainty-id",
  "inverse_squared_uncertainty-id",
  "spill_over-id",
  "inc_squared_spill_over-id",
  "count_uncertainty_squared-id",
  "sample_quantity_uncertainty_squared-id",
  "critical_limit-id",
];

export const idsBRISO: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "inc_of_calibration_source_volume_at_0-id",
  "squared_counting_uncertainty_of_calibration_source_at_0-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  "inc_count_squared_fc_without_agent_extintor-id",
  "secondary_pattern_activity_of_the_fc_with_the_greatest_amount-id",
  "inc_squared_of_the_activity_of_the_secondary_standard-id",
  "relative_uncertainty-id",
  "inverse_squared_uncertainty-id",
  "spill_over-id",
  "inc_squared_spill_over-id",
  "count_uncertainty_squared-id",
  "sample_quantity_uncertainty_squared-id",
  "critical_limit-id",
  "efficiency_y_90-id",
  "mass_with_greatest_amount_of_scintillator-id",
  "inc_mass_with_greatest_amount_of_scintillator-id",
  "calibration_source_cpm-id",
  "inc_count_squared_fc_with_greater_amount_of_scintillator-id",
  "dpm_fc_k40_with_less_kci-id",
  "inc_squared_dpm_fc_k40_with_less_kci-id",
  "k40_relative_uncertainty-id",
  "uncertainty_squared_relative_inverse_sample_efficiency-id",
  "inc_rel_squared_sample_vial_quantity-id",
  "calibration_source_count_rate_uncertainty_squared-id",
  "inc_squared_activity_source_calibration_without_agent_extintor-id",
  "br_critical_limit-id",
];

export const idsBRCurrier: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "spill_over-id",
  "efficiency_y_90-id",
  "calibration_source_count_rate_uncertainty_squared-id",
];

export const idsBTISO: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "primary_pattern_activity-id",
  "primary_pattern_uncertainty-id",
  "primary_pattern_mass_mpp-id",
  "primary_pattern_mass_uncertainty-id",
  "secondary_pattern_mass-id",
  "secondary_pattern_mass_uncertainty-id",
  "inc_of_calibration_source_volume_at_0-id",
  "squared_counting_uncertainty_of_calibration_source_at_0-id",
  "cpm_of_the_fc_with_largest_amount_of_scintillator-id",
  "inc_count_squared_fc_without_agent_extintor-id",
  "secondary_pattern_activity_of_the_fc_with_the_greatest_amount-id",
  "inc_squared_of_the_activity_of_the_secondary_standard-id",
  "relative_uncertainty-id",
  "inverse_squared_uncertainty-id",
  "spill_over-id",
  "inc_squared_spill_over-id",
  "count_uncertainty_squared-id",
  "sample_quantity_uncertainty_squared-id",
  "critical_limit-id",
];

export const idsBTCurrier: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "spill_over-id",
];

export const idsBTBRCurrier: string[] = [
  "efficiency-id",
  "cpm_fondo_beta-id",
  "cpm_fondo-id",
  "counting_time-id",
  "spill_over-id",
];

export const idsBTBRInSample: string[] = [
  "efficiency_y_90-id",
  "mass_with_greatest_amount_of_scintillator-id",
  "inc_mass_with_greatest_amount_of_scintillator-id",
  "calibration_source_cpm-id",
  "inc_count_squared_fc_with_greater_amount_of_scintillator-id",
  "dpm_fc_k40_with_less_kci-id",
  "inc_squared_dpm_fc_k40_with_less_kci-id",
  "k40_relative_uncertainty-id",
  "uncertainty_squared_relative_inverse_sample_efficiency-id",
  "inc_rel_squared_sample_vial_quantity-id",
  "calibration_source_count_rate_uncertainty_squared-id",
  "inc_squared_activity_source_calibration_without_agent_extintor-id",
  "br_critical_limit-id",
];

export const idsBTBRInSampleCurrier: string[] = [
  "efficiency_y_90-id",
  "calibration_source_count_rate_uncertainty_squared-id",
];

export const idsPuAmCM: string[] = [
  "efficiency-id",
  "efficiency_sr_89-id",
  "inc_rel_squared_performance-id",
];
